/* global gapi */
// @material-ui/core
import { Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";

class Logout extends Component {
  static propTypes = {
    setLogin: PropTypes.func.isRequired
  };

  componentDidMount() {
    gapi.auth2.getAuthInstance().signOut();
    this.props.setLogin(false);
    this.props.history.push("/");
  }

  render() {
    return (
      <Typography variant="subheading">You are being logged out!</Typography>
    );
  }
}

export default withRouter(Logout);



// WEBPACK FOOTER //
// ./src/pages/Logout.js